import {
  COMPARE_SUMMARY_NAMES,
  LID_COMPARISON_EXPORT_TYPES,
  LID_EVENT_TYPES,
  LID_EXPORT_FORMATS,
  LID_STATUSES,
  LidEventType,
  LidStatus,
} from './enums';

import successStatus from '../app/assets/successStatus.svg';
import failedStatus from '../app/assets/failedStatus.svg';
import almostStatus from '../app/assets/almostStatus.svg';

export const COMPARE_TOOLTIP_MAP: Record<string, string> = {
  [COMPARE_SUMMARY_NAMES.MEMBER_COUNT_COMPARISON]:
    'The total number of members in your AIRES Shares file exceeds the 10% margin of error allowed by the NCUA when compared with the number of members in your Call Report.',
  [`${COMPARE_SUMMARY_NAMES.MEMBERS_NOT_QUALIFIED_AS_LID}POSITIVE`]:
    'The decrease of members is a positive change - less members now fall outside the criteria for LID qualification.',
  [`${COMPARE_SUMMARY_NAMES.MEMBERS_NOT_QUALIFIED_AS_LID}NEGATIVE`]:
    'The increase of members is a negative change - more members now fall outside the criteria for LID qualification.',
};

export const LID_STATUS_COLORS_MAP: Record<LidStatus, string> = {
  [LID_STATUSES.MET]: '#52b36b',
  [LID_STATUSES.CLOSE]: '#f9a31d',
  [LID_STATUSES.NOT_MET]: '#ed5050',
};

export const LID_STATUS_ICONS_MAP: Record<LidStatus, string> = {
  [LID_STATUSES.MET]: successStatus,
  [LID_STATUSES.CLOSE]: almostStatus,
  [LID_STATUSES.NOT_MET]: failedStatus,
};

export const LID_EVENT_TYPES_MAP: Record<LidEventType, string> = {
  [LID_EVENT_TYPES.NONE]: 'Unknown',
  [LID_EVENT_TYPES.AIRES_FILE_UPLOAD]: 'AIRES File Upload',
  [LID_EVENT_TYPES.AIRES_FILE_UPLOAD_AND_CUSTOM_FLAGS]:
    'AIRES File Upload with Custom Flags',
  [LID_EVENT_TYPES.AIRES_PLUS_FILE_UPLOAD]: 'AIRES+ Files Upload',
  [LID_EVENT_TYPES.AIRES_PLUS_FILE_UPLOAD_AND_CUSTOM_FLAGS]:
    'AIRES+ Files Upload with Custom Flags',
  [LID_EVENT_TYPES.ENRICHMENT_BUSINESS_ADDRESS]:
    'Enrichment: Business Addresses',
  [LID_EVENT_TYPES.ENRICHMENT_COLLEGE_STUDENT]: 'Enrichment: College Students',
  [LID_EVENT_TYPES.NCUA_WORKBOOK_UPDATE]: 'NCUA Workbook Update',
  // don't used on the frontend
  [LID_EVENT_TYPES.REPROCESS_SUBMISSION]: 'REPROCESS_SUBMISSION',
  [LID_EVENT_TYPES.NCUA_WORKBOOK_UPDATE_OUTDATED]:
    'NCUA_WORKBOOK_UPDATE_OUTDATED',
};

export const LID_EVENT_TYPES_FILTER = new Map<number, string>([
  [-1, 'All'],
  [LID_EVENT_TYPES.AIRES_FILE_UPLOAD, 'AIRES File Upload'],
  [
    LID_EVENT_TYPES.AIRES_FILE_UPLOAD_AND_CUSTOM_FLAGS,
    'AIRES File Upload with Custom Flags',
  ],
  [LID_EVENT_TYPES.AIRES_PLUS_FILE_UPLOAD, 'AIRES+ Files Upload'],
  [
    LID_EVENT_TYPES.AIRES_PLUS_FILE_UPLOAD_AND_CUSTOM_FLAGS,
    'AIRES+ Files Upload with Custom Flags',
  ],
  [
    LID_EVENT_TYPES.ENRICHMENT_BUSINESS_ADDRESS,
    'Enrichment: Business Addresses',
  ],
  [LID_EVENT_TYPES.ENRICHMENT_COLLEGE_STUDENT, 'Enrichment: College Students'],
  [LID_EVENT_TYPES.NCUA_WORKBOOK_UPDATE, 'NCUA Workbook Update'],
]);

export const LID_LINE_CHART_BLOCK_ID = 'lidLineChartBlock';
export const LID_DETAILS_BLOCK_ID = 'lidDetailsBlock';

export const LID_COMPARISON_EXPORT_MAP = {
  [LID_COMPARISON_EXPORT_TYPES.GENERAL]: {
    title: 'Export Comparison Report',
    url: '/api/lid/ComparisonDetailsExport',
  },
  [LID_COMPARISON_EXPORT_TYPES.DETAILED]: {
    title: 'Export Detailed Report',
    url: '/api/lid/DetailedComparisonMemberExport',
  },
};

export const LID_STATS_ACTIVE_TAB = 'activeStatsTab';

const LID_EXPORT_ACMD_TOOLTIP_MESSAGE =
  'Use this option if the file is needed for a decryption tool.';
const LID_EXPORT_EXCEL_TOOLTIP_MESSAGE =
  'Use this option to view the data in a user-friendly spreadsheet format.';
const LID_EXPORT_CSV_TOOLTIP_MESSAGE = '';

export const LID_EXPORT_FORMATS_MAP = {
  [LID_EXPORT_FORMATS.ACMD]: {
    formatValue: LID_EXPORT_FORMATS.ACMD,
    hint: 'for Decryption Tool',
    tooltipMessage: LID_EXPORT_ACMD_TOOLTIP_MESSAGE,
  },
  [LID_EXPORT_FORMATS.EXCEL]: {
    formatValue: LID_EXPORT_FORMATS.EXCEL,
    hint: 'for Excel',
    tooltipMessage: LID_EXPORT_EXCEL_TOOLTIP_MESSAGE,
  },
  [LID_EXPORT_FORMATS.CSV]: {
    formatValue: LID_EXPORT_FORMATS.CSV,
    hint: 'for CSV',
    tooltipMessage: LID_EXPORT_CSV_TOOLTIP_MESSAGE,
  },
};
